import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { provideFeatureAddonRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let CloudinaryFrontendAdminFeature = /*#__PURE__*/(() => {
  let CloudinaryFrontendAdminFeature = class CloudinaryFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/cloudinary/frontend-admin","featureId":"common-cloudinary"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          label: 'Cloudinary Tools',
          routerLink: 'media/cloudinary-tools',
          displayInGroup: 'media'
        }]
      });
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵCloudinaryFrontendAdminFeature_BaseFactory;
        return function CloudinaryFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵCloudinaryFrontendAdminFeature_BaseFactory || (ɵCloudinaryFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(CloudinaryFrontendAdminFeature)))(__ngFactoryType__ || CloudinaryFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: CloudinaryFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideFeatureAddonRoutes([{
          useAddonSlot: 'media',
          path: 'cloudinary-tools',
          loadChildren: () => import('./cloudinary-admin.module').then(m => m.CloudinaryFrontendAdminModule)
        }])],
        imports: [CommonModule]
      });
    }
  };
  CloudinaryFrontendAdminFeature = __decorate([ClassName("CloudinaryFrontendAdminFeature")], CloudinaryFrontendAdminFeature);
  return CloudinaryFrontendAdminFeature;
})();
export { CloudinaryFrontendAdminFeature };